module.exports = __webpack_public_path__ + "media/images/emblems/Preverenges-coat_of_arms-7adcc7ae9ef74f7d9df34fc6806a3b7c.svg";